import { Tag, Col, PageHeader, Row, Tooltip } from 'antd'
import { InfoCircleOutlined, InfoCircleTwoTone, CheckCircleTwoTone  } from '@ant-design/icons'
import moment from 'moment'
import * as React from 'react'
import { RaccoltaDatiModel } from '../../models/RaccoltaDatiModels'

import { IRaccoltaDatiService } from '../../services/RaccoltaDatiService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { MonthSwitcher } from '../MonthSwitcher'
import { TableEntrate } from '../raccoltaDati/TableEntrate'
import { TableSaldoCC } from '../raccoltaDati/TableSaldoCC'
import { TableUscite } from '../raccoltaDati/TableUscite'

import { formatEuro } from '../shared/CurrencyFormat'
import { TTFormItem } from '../shared/TTFormItem'
import { YearPicker } from './YearPicker'
import Icon from '@ant-design/icons/lib/components/AntdIcon'

interface TabRaccoltaDatiProps {
    clienteId: string
}

class TabRaccoltaDatiState extends RaccoltaDatiModel {
    Anno: number = 2021
}

export class TabRaccoltaDati extends React.Component<TabRaccoltaDatiProps, TabRaccoltaDatiState> {

    service: IRaccoltaDatiService

    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.RACCOLTA_DATI_SERVICE)
        this.state = new TabRaccoltaDatiState()
    }

    componentDidMount() {
        let date = moment()
        this.loadPage(date.format() as any)
    }

    loadPage = async (periodo: Date) => {
        this.setState({ Periodo: periodo })
        let resp = await this.service.Get(periodo, this.props.clienteId)
        if (resp.IsValid == true)
            this.setState(resp)
    }

    onAnnoChange = (value: number) => {
        this.setState({ Anno: value })
        let date = moment([value, moment(this.state.Periodo).month()])
        this.loadPage(date.format() as any)
    }

    renderYears = () => {
        return <YearPicker clienteId={this.props.clienteId} onAnnoChange={value => this.onAnnoChange(value)} />
    }

    renderCreditiNonSaldati = (value?: number) => {
        if (!this.state.ConfigFatturazione || value == null) return "";
        let euro = formatEuro(value);
        let tooltip = "Crediti non saldati " + euro + ". Il valore visualizzato è stato letto dalle scadenze non pagate delle fatture di Vendita";
        return this.renderTooltip(tooltip);
    }

    renderDebitiNonSaldati = (value?: number) => {
        if (!this.state.ConfigFatturazione || value == null) return "";
        let euro = formatEuro(value);
        let tooltip = "Debiti non saldati " + euro + ". Il valore visualizzato è stato letto dalle scadenze non pagate delle fatture di Acquisto";
        return this.renderTooltip(tooltip);
    }

    renderTooltip = (title: string)=>{
        return <Tooltip placement="right" title={title}><InfoCircleTwoTone twoToneColor="#1890ff" /></Tooltip>;
    }

    render() {
        return (
            <PageHeader title="Raccolta dati" extra={this.renderYears()}>
                <MonthSwitcher value={moment(this.state.Periodo)} onChange={e => this.loadPage(e.format() as any)} />

                <Row gutter={[10, 30]}>
                    <Col xs={24} lg={12} xl={6}>
                        <TTFormItem label="Fatturato">
                            {formatEuro(this.state.Fatturato)}
                        </TTFormItem>
                    </Col>
                    <Col xs={24} lg={12} xl={6}>
                        <TTFormItem label="Crediti Scaduti">
                            {formatEuro(this.state.Crediti)} {this.renderCreditiNonSaldati(this.state.CreditiNonSaldati)}
                        </TTFormItem>
                    </Col>
                    <Col xs={24} lg={12} xl={6}>
                        <TTFormItem label="Debiti Scaduti">
                            {formatEuro(this.state.Debiti)} {this.renderDebitiNonSaldati(this.state.DebitiNonSaldati)}
                        </TTFormItem>
                    </Col>
                    <Col xs={24} lg={12} xl={6}>
                        <TTFormItem label="Incassato">
                            {formatEuro(this.state.Incassato)}
                        </TTFormItem>
                    </Col>
                </Row>

                <TableSaldoCC saldi={this.state.Saldi} />
                <br />
                <br />


                <TableUscite uscite={this.state.Uscite} />
                <TableEntrate entrate={this.state.Entrate} />
            </PageHeader>
        )
    }
}